import { render, staticRenderFns } from "./acceptingTradeRequest.vue?vue&type=template&id=5bc0825a&scoped=true&"
import script from "./acceptingTradeRequest.vue?vue&type=script&lang=ts&"
export * from "./acceptingTradeRequest.vue?vue&type=script&lang=ts&"
import style0 from "./acceptingTradeRequest.vue?vue&type=style&index=0&id=5bc0825a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0825a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VProgressCircular})
